import React, { useState, useEffect } from "react";
import { Modal, Select, Input, Form, Button } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";
import { callApi } from "../../api/apiCaller";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const getAllClients = async () => {
      let getRes = (res) => {
        console.log("Response received by clients.....", res);
        setClients(res?.data?.users || []);
      };

      await callApi(
        "GET",
        `${routes.getUsers}?role=Client`,
        null,
        setIsLoading,
        getRes,
        (error) => {
          console.log("Error fetching clients:", error);
        }
      );
    };
    getAllClients();
  }, []);

  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          clientId: recordData.clientId?._id,
          name: recordData.name,
          email: recordData.email,
          number: recordData.number,
          address: recordData.address,
        });
      } else {
        form.resetFields(); // Ensure the form is cleared when adding a new sub-client
      }
    }
  }, [visible, recordData, form]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          clientId: values.clientId,
          name: values.name,
          email: values.email,
          number: values.number,
          address: values.address,
          role: "SubClient",
        };

        if (!recordData) {
          requestBody.password = values.password;
        }

        const getRes = (res) => {
          if (res.status === 400) {
            RedNotify(res.message || "Validation Error");
          } else if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Sub Client updated successfully."
                : "Sub Client created successfully."
            );
            toggleModal();
          } else {
            RedNotify("An error occurred. Please try again later.");
          }
        };

        callApi(
          recordData ? "PATCH" : "POST",
          recordData
            ? `${routes.updateClient}/${recordData._id}`
            : `${routes.createClient}`,
          requestBody,
          setIsLoading,
          getRes,
          (error) => {
            console.error("API call error", error);
            RedNotify("An error occurred. Please try again later.");
          }
        );
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
        RedNotify("Please ensure all fields are filled out correctly.");
      });
  };

  return (
    <Modal
      title={recordData ? "Update Sub Client" : "Create Sub Client"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
        >
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        {/* Client Dropdown */}
        <Form.Item
          name="clientId"
          label="Client"
          rules={[{ required: true, message: "Please select a client" }]}
        >
          <Select
            placeholder="Select Client"
            optionFilterProp="children"
            showSearch
          >
            {clients.map((client) => (
              <Select.Option key={client._id} value={client._id}>
                {client.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter name" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter email" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Number"
          name="number"
          rules={[{ required: true, message: "Please enter number" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true, message: "Please enter address" }]}
        >
          <Input />
        </Form.Item>

        {!recordData && (
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AddVideo;
